import React from 'react'

import cn from '../../libs/class-names'
import {mapChildrenWithFragments} from '../../services/react-children'

export interface Props {
  classNames?: string[]
  children?: React.ReactNode[]
  maxLength?: number
  space?: 'default' | 'l'
}

const sliceList = (list: React.ReactNode[], maxLength: number) => {
  const truncatedList = list.slice(0, maxLength)
  const moreList = list.slice(maxLength)

  return [truncatedList, moreList.length] as const
}

const TruncatedListWithCount = ({
  classNames,
  children,
  maxLength = 5,
  space = 'default',
}: Props) => {
  const [list, moreLength] = sliceList(
    mapChildrenWithFragments(children, child => child),
    maxLength
  )

  return (
    <div className={cn('TruncatedListWithCount', {[`space-${space}`]: !!space}, classNames)}>
      {list}
      <span className="TruncatedListWithCount__count">
        {moreLength > 0 ? `+${moreLength}` : <>&nbsp;</>}
      </span>
    </div>
  )
}

export default TruncatedListWithCount
